import React from "react";

const InitialsAvatar = ({ name }) => {
  const getInitials = () => {
    const words = name.split(" ");
    const initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join("");
    return initials.toUpperCase();
  };

  return (
    <div className="beneficiary-btn-avatar w-11 h-11 rounded-full flex items-center justify-center text-xl font-bold">
      {getInitials()}
    </div>
  );
};

export default InitialsAvatar;
